import React from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';

function AddLeaveSetting() {
  const { register, handleSubmit, errors } = useForm();

  const generate_password = () => {
  };

  const onSubmit = () => {
    window.location.href = '/leave-page/leave-setting';
  };

  return (
    <div className="form-table">
      <div className="table-heading text-left p-1">
      <span className='breachCrumb'>
              <Link to="/leave-page/leave-setting">Leave Setting</Link> /{' '}
              <Link to="/AddLeaveSetting">Add Leave</Link>
        </span>
        <h5>Add Leave </h5>
      </div>

        <div className="input-form p-3">
          <div className="row d-flex">
            <div className="col-md-6 pr-3">
              <div className="form-group">
                <div className="input-group">
                <span>Leave Policy</span>
                  <select style={{ width: '500px'}}>
                        <option value="" disabled selected>Select Leave Policy</option>
                        <option value="John">John</option>
                        <option value="Jane">Jane</option>
                        <option value="Doe">Doe</option>
                    </select>
                  <span className="warning"></span>
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <span>Leave Enable</span>
                  <input
                    type="text"
                    placeholder="Enter leave enable"
                   
                  />
                  <span className="warning"></span>
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <span>Leave Type</span>
                  <input
                    type="text"
                    placeholder="Leave Type"
                   
                  />
                  <span className="warning"></span>
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <span>Effective Date</span>
                  <input
                    type="date"
                    placeholder="Enter your first name"
                   
                  />
                  <span className="warning"></span>
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <span>Initial Set To Day</span>
                  <input
                    type="number"
                    placeholder="number of days"
                    
                  />
                  <span className="warning"></span>
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <span>Earn Days</span>
                  <input
                    type="number"
                    placeholder="Enter your email"
                    
                  />
                  <span className="warning"></span>
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <span>Earn Period</span>
                  <input
                    type="text"
                    placeholder="Enter "
                   
                  />
                  <span className="warning"></span>
                </div>
              </div>
            </div>
            
            
            <div className="col-md-6 pl-3">
              <div className="form-group">
                <div className="input-group">
                  <span>Reset At</span>
                  <input
                    type="text"
                    placeholder="Enter your first name"
                   
                  />
                  <span className="warning"></span>
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <span>Reset Days</span>
                  <input
                    type="number"
                    placeholder="Enter "
                   
                  />
                  <span className="warning"></span>
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                <span>Restricted Day Off</span>
                  <select style={{ width: '500px'}}>
                        <option value="" disabled selected>Select True or False</option>
                        <option value="John">True</option>
                        <option value="Jane">False</option>
                    </select>
                  <span className="warning"></span>
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                <span>Special Case</span>
                  <select style={{ width: '500px'}}>
                        <option value="" disabled selected>Select True or False</option>
                        <option value="John">True</option>
                        <option value="Jane">False</option>
                    </select>
                  <span className="warning"></span>
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <span>Approval Department</span>
                  <input
                    type="text"
                    placeholder="Enter your first name"
                   
                  />
                  <span className="warning"></span>
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <span>Max Consicutive Days</span>
                  <input
                    type="number"
                    placeholder="Enter your first name"
                   
                  />
                  <span className="warning"></span>
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <span>Description Required</span>
                  <select style={{ width: '500px'}}>
                        <option value="" disabled selected>Select True or False</option>
                        <option value="John">True</option>
                        <option value="Jane">False</option>
                    </select>
                  <span className="warning"></span>
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <span>Restricted Date</span>
                  <input
                    type="date"
                    placeholder="Enter your first name"
                   
                  />
                  <span className="warning"></span>
                </div>
              </div>
            </div>
          </div>
          <div className="button-next mt-3">
                <button type="submit" className="button-pre" onClick={onSubmit}>
                submit
                </button>
        </div>
        </div>  
    </div>
   
  );
}

export default AddLeaveSetting;
